import { useEffect, useState } from 'react';

import { useParams } from 'react-router-dom';

import { Button, Icon } from '@wf/components';
import { Tooltip } from '@wf/sw-ui-kit';

import RiskTooltipContent from './RiskTooltipContent';

import { RiskColor } from '../../types/enums';

import { getLpcoRisks } from '../../services/risk';

import styles from './RiskStatus.module.scss';

const riskIconNamesByColor: Record<RiskColor, string> = {
  [RiskColor.GREEN]: 'ic_clean',
  [RiskColor.BLUE]: 'ic_post_clearance',
  [RiskColor.YELLOW]: 'ic_documentarycheck',
  [RiskColor.ORANGE]: 'ic_X_rey',
  [RiskColor.RED]: 'ic_physical_examination',
  [RiskColor.PURPLE]: 'ic_OGA_inspection',
  [RiskColor.NONE]: '',
};

interface IRiskItem {
  color: RiskColor;
  name: string;
  message: string;
}

function RiskStatus() {
  const { id = '' } = useParams();
  const [riskData, setRiskData] = useState<IRiskItem | null>(null);

  useEffect(() => {
    async function getRisk() {
      try {
        const { data } = await getLpcoRisks(id);
        const currentItem = data.at(-1);

        if (currentItem) {
          const { finalColor, rules } = currentItem;

          if (finalColor !== RiskColor.NONE) {
            const rule = rules.find(({ lines }) =>
              lines.some((line) => line.color === finalColor && line.itemId === null)
            );
            let message = '';

            if (rule) {
              message =
                rule?.lines.reduce((acc, cv) => {
                  if (!cv.itemId && cv.message) return acc + cv.message + '\n';

                  return acc;
                }, '') ?? '';

              setRiskData({
                color: finalColor,
                name: rule?.name,
                message,
              });
            }
          }
        }
      } catch (e) {
        console.error(e);
      }
    }

    void getRisk();
  }, [id]);

  return (
    <>
      {riskData ? (
        <div className={styles.wrapper}>
          <div className={styles.line} />
          <Tooltip
            tooltipContent={
              <RiskTooltipContent title={riskData.name} content={riskData.message} colorName={riskData.color} />
            }
            contentClassName={styles.tooltipContent}
            triggers={['click']}
            placement="bottom"
            offset={-4}
          >
            <Button isSquare ghost>
              <Icon name={riskIconNamesByColor[riskData.color]} />
            </Button>
          </Tooltip>
        </div>
      ) : null}
    </>
  );
}

export default RiskStatus;
